import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/User/Auth/Login'
import {
  order,
  manage,
  label
} from './router'
Vue.use(Router)
const router = new Router({
  routes: [{
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: {
      nonauth: true
    }
  },
  {
    path: '/',
    redirect: '/Home/Label/LabelList'
  },
  {
    path: '/Home',
    redirect: '/Home/Label/LabelList'
  },
  {
    path: '/Home',
    name: 'Home',
    component: resolve => require(['@/components/Home'], resolve),
    children: [
      ...order,
      ...label,
      ...manage
    ]
  }
  ]
})
// 没有登录就会跳转到登录页面
router.beforeEach((to, from, next) => {
  const labelUser = localStorage.getItem('zlg_label_userinfo')
  const needLogin = !!sessionStorage.getItem('needLoginAgain')
  // if (to.name === 'ManageList' && JSON.parse(labelUser).role !== 4) {
  //   next({path: '/Login'})
  //   return false
  // }
  // if (to.name === 'OrderList' && JSON.parse(labelUser).role !== 0) {
  //   next({path: '/Login'})
  //   return false
  // }
  if (to.name !== 'Login' && !needLogin) {
    next({
      path: '/Login'
    })
    return
  }
  if (labelUser || to.meta.nonauth) {
    if (to.path === '/Home/Manage/ManageList') {
      let username = ''
      try {
        username = JSON.parse(labelUser).username
      } catch (e) {
        username = ''
      }
      if (username === 'admin') {
        next()
      } else {
        next({path: from.path})
      }
    } else {
      next()
    }
  } else {
    next({
      path: '/Login'
    })
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js